module.exports = __webpack_public_path__ + "static/img/kdSimulator_2.ab4214f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/kdSimulator_2.jpg
// module id = m6l4
// module chunks = 1